import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from "@mui/material/InputAdornment";
import Stack from '@mui/material/Stack';

import Form from '../../Common/Form';
import ItemPicker from '../../Common/Form/ItemPicker';
import LoadingDetailsView from '../../Common/Skeletons/LoadingDetailsView';

import ItemsList from '../../Item/ItemsList';
import LocationList from '../../Location/LocationList';

// There is no Edit mode for the Inventory Stock form. 
// If an edit is needed, it should be done via Inventory Stock Adjustment form.
const InventoryStockForm = (
    defaultItem = null, // if given, preselect this item in the form
    defaultLocation = null // if given, preselect this location in the form
) => {

    const navigate = useNavigate();

    const [selectedItem, setSelectedItem] = useState(defaultItem);
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);

    // --- Handle input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });

        // Set the selected item state if item is changed
        if (e.target.name === 'itemId') {
            console.debug('Selected item changed: ', e.target.item);
            setSelectedItem(e.target.item);
        }
    };


    // Debug formData update
    useEffect(() => {
        console.debug('Form Data: ', formData);
    }, [formData]);

    useEffect(() => {
        console.debug('Selected Item: ', selectedItem);
    }, [selectedItem]);

    // Show skeliton while loading initial data (if in edit mode)
    if (loading)
        return <LoadingDetailsView />


    return (
        <Box sx={{ padding: { xs: 2, sm: 3 }, maxWidth: '800px' }}>
            <Form
                resourceName='Inventory Stock'
                apiPath='/tenants/inventory/stocks/add'
                formData={formData}
                requiredFields={
                    [
                        { name: 'itemId', label: 'Item' },
                        { name: 'locationId', label: 'Location' },
                        { name: 'quantity', label: 'Quantity' },
                    ]
                }
                onSubmit={() => {
                    navigate(-1);
                }}
                onCancel={() => {
                    navigate(-1);
                }}
            >
                <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <ItemPicker
                            label="Item *"
                            name="itemId"
                            ListView={ItemsList}
                            filters={{ isStockable: true }}
                            onChange={handleChange}
                        />
                        <ItemPicker
                            label="Location *"
                            name="locationId"
                            ListView={LocationList}
                            onChange={handleChange}
                        />
                    </Stack>

                    {/* Contact Details Group */}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Quantity"
                            name="quantity"
                            type='number'
                            // The InputProps with uppercase I is for MUI TextField component
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <span style={{ color: "#666", userSelect: "none" }}>
                                            {selectedItem?.uom || ''}
                                        </span>
                                    </InputAdornment>
                                ),
                            }}

                            // for inputProps with lowercase i is for the native input element
                            inputProps={{
                                onWheel: (e) => e.currentTarget.blur(), // Prevent changing number input on wheel/scroll    
                            }}

                            value={formData.quantity || ''}
                            onChange={handleChange}
                            required
                            fullWidth
                            disabled={!selectedItem} // Disable if item not selected
                        />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Note"
                            name="notes"
                            value={formData.notes || ''}
                            onChange={handleChange}
                            multiline
                            rows={4}
                            fullWidth
                        />
                    </Stack>
                </Stack>
            </Form>
        </Box>
    );
};

export default InventoryStockForm;